import {omit} from 'external/lodash'
import {Link, forwardRef} from 'external/react'
import useProfile from 'hooks/profile'

const LinkBehavior = forwardRef(
  (props, ref) => {
    const {locked} = useProfile()
    return (
      <Link
        ref={ref}
        to={locked ? '#' : props.to}
        {...omit(props, ['to'])}
      />
    )
  }
)

LinkBehavior.displayName = 'link'
export {LinkBehavior as default}
